import React, { useState } from 'react';
import { Trans } from 'gatsby-plugin-react-i18next';
import classnames from 'classnames';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { ADDRESSES } from '../../common/webSiteVariables';
import { useGlobalData } from '../../../providers/globalDataProvider/globalDataProvider.useGlobalData';
import WorldMap from '../../../images/aboutUs/world_map_white.svg';
import './who.where.less';

const Where = () => {
  const { t } = useTranslation();
  const { country: currentCountry } = useGlobalData();
  const [country, setCountry] = useState(currentCountry);
  const countries = Object.keys(ADDRESSES);

  return (
    <div className="o-whoWhere">
      <div className="m-globalContentContainer -block">
        <h1 className="a-whoWhere__title -page-title">
          <Trans>web.about.where.title</Trans>
        </h1>
        <div className="m-whoWhere__selectorsMapContainer">
          <div className="m-whoWhere__countryList">
            <ul className="m-whoWhere__list">
              {countries.map((value) => (
                <li
                  key={value}
                  id={value}
                  onClick={() => setCountry(value)}
                  className={classnames('a-whoWhere__country', {
                    '-selected': value === country,
                  })}
                >
                  <Trans>{`ct_${value}`}</Trans>
                </li>
              ))}
            </ul>
          </div>
          <div className="m-whoWhere__mapContainer">
            <img
              src={WorldMap}
              className="a-whoWhere__worldMap"
              width={815}
              height={436}
              title={t('images.world.map.title')}
              alt={t('images.world.map.alt')}
            />
            {Object.values(ADDRESSES).map((value, key) => {
              return value.map((address) => (
                <React.Fragment key={key}>
                  <div
                    className={classnames('a-whoWhere__mark', {
                      '-selected': address.code === country,
                    })}
                    style={{
                      top: `${address.position.top}%`,
                      left: `${address.position.left}%`,
                    }}
                    onClick={() => setCountry(address.code)}
                    title={t('images.location.pin.title')}
                    alt={t('images.location.pin.alt')}
                  />
                  <div
                    className={classnames('m-whoWhere__cityList', {
                      '-selected': address.code === country,
                    })}
                    style={{
                      top: `${address.position.top}%`,
                      left: `${address.position.left}%`,
                    }}
                  >
                    <ul className="m-whoWhere__listCityul">
                      {ADDRESSES[country].map((completeAddress) => (
                        <li
                          className="a-whoWhere__city"
                          key={completeAddress.city}
                        >
                          <address className="m-whoWhere__addressItem">
                            <p className="a-whoWhere__addressDetails -city">
                              <Trans>{completeAddress.city}</Trans>
                              <span>, </span>
                              <Trans>{completeAddress.country}</Trans>
                            </p>
                            <p className="a-whoWhere__addressDetails -address">
                              {completeAddress.address1}
                            </p>
                            <p className="a-whoWhere__addressDetails -address">
                              {completeAddress.address2}
                            </p>
                            <br />
                          </address>
                        </li>
                      ))}
                    </ul>
                  </div>
                </React.Fragment>
              ));
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Where;
